export default "__VITE_ASSET__7ade0580__"